import { Outlet } from '@tanstack/react-router'
import { useThemeInitializer } from '@/hooks/useThemeInitializer'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { cn } from '@/utils/tailwind-util'
import { useAppStore } from '@/store/useAppStore'
import { Header } from './Header'
import { Sidebar } from '@/components/layouts/main/Sidebar'
import { Toaster } from '@/components/ui/toaster'
import { SessionExpiredModal } from '@/components/features/auth/SessionExpiredModal'

export function Layout() {
  const sidebarOpen = useAppStore((state) => state.sidebarOpen)
  const isDesktop = useMediaQuery('md')

  useThemeInitializer()

  return (
    <>
      <div className="flex h-screen bg-background w-full">
        {/* Sidebar */}
        <Sidebar />

        {/* Main content */}
        <div className={cn(
          "w-full flex-1 flex flex-col transition-all duration-300",
          isDesktop && "ml-16",
          isDesktop && sidebarOpen && "ml-50"
        )}>
          {/* Header */}
          <Header />

          {/* Page content */}
          <main className="w-full flex-1 overflow-auto p-4 sm:p-6" id="mainLayout">
            <Outlet />
          </main>
        </div>
      </div>
      <Toaster />
      <SessionExpiredModal />
    </>
  )
}
